import {Component, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, IonContent, IonList, IonItem, IonLabel } from "@ionic/angular/standalone";
import {CreatePlanPage} from "../create-plan/create-plan.page";
import {Plan} from "../../model/plan.model";
import {PlanService} from "../../services/plan.service";
import {Router} from "@angular/router";
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SexyModule} from '@qid/sexy';
import {SuperButtonComponent} from '@qid/super';

@Component({
  selector: 'app-list-plan',
  templateUrl: './list-plan.page.html',
  styleUrls: ['./list-plan.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonIcon,
    IonContent,
    IonList,
    IonItem,
    IonLabel
  ]
})
export class ListPlanPage implements OnInit {

  public plans : Plan[] =[]

  constructor(private modalController: ModalController,
              private planService : PlanService,
              private router : Router
              ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter(){
    this.fetchAllPlans();
  }

  async addPlan() {
    const modal = await this.modalController.create({
      component: CreatePlanPage
    })
    await modal.present();
    const res = await modal.onDidDismiss();
    if(res && res?.data?.plan){
      this.plans.push(res.data.plan)
    }
  }

  public async fetchAllPlans(){
    const res = await this.planService.readAll()
    if(res){
      this.plans = res
    }
  }

  public openViewPlanPage(plan : Plan){
    this.router.navigateByUrl('menu/view-plan/' + plan._id)
  }
}
